<template>
    <v-sparkline :value="value" :gradient="gradient" :smooth="radius || false" :padding="padding" :line-width="lineWidth"
    :stroke-linecap="lineCap"
    :gradient-direction="gradientDirection"
    :fill="fill"
    :type="type"
    :auto-line-width="autoLineWidth"
    auto-draw
    :show-labels="showLabels"
    :label-size="labelSize">
    </v-sparkline>    
</template>

<script>
import lodash from 'lodash'
import moment from 'moment'

const TIME_DIFF = 9
const gradients = [
  ['#222'],
  ['#42b3f4'],
  ['red', 'orange', 'yellow'],
  ['purple', 'violet'],
  ['#00c6ff', '#F0F', '#FF0'],
  ['#f72047', '#ffd200', '#1feaea'],
]

export default {
    props: [ 'price', 'discounts' ],
    data: () => ({
        showLabels: false,
        lineWidth: 2,
        labelSize: 7,
        radius: 10,
        padding: 8,
        lineCap: 'round',
        gradient: gradients[5],
        value: [],
        gradientDirection: 'top',
        gradients,
        fill: false,
        type: 'trend',
        autoLineWidth: false,
    }),
    created () {
        if (this.discounts && this.discounts.length > 0) {
            let discountFlows = []
            this.discounts.forEach(discount => {
                discountFlows.push(discount.sprice)
                if (moment(discount.edate, 'YYYY-MM-DD HH:mm:ss').add(TIME_DIFF, 'hours') < moment()) {
                    discountFlows.push(this.sprice)
                }
            })
            this.value = lodash.concat([this.price], discountFlows)
        } else {
            this.value = [ this.price, this.price ]
        }
        console.log(this.value)        
    }
}
</script>

<style scoped>

</style>